import styled from 'styled-components';

const StyledLabel = styled.label`
  margin-right: 5px;
  font-size: 15px;
  @media (min-width: 1440px) {
    font-size: 17px;
  }
`;
export default StyledLabel;
